import {Button, Spinner} from '@chakra-ui/react';
import {SwitchIcon} from '@/components/svg/SwitchIcon';
import NiceModal from '@ebay/nice-modal-react';
import {ModaleRemplacementCatalogue} from '../../components/ModaleRemplacementCatalogue';
import {useTranslation} from 'react-i18next';
import {LigneDePanierCommands} from 'ff-common/src/hooks/ligneDePanier/use-ligne-de-panier-commands';
import {State} from '@synako/halitrek';
import {LigneDePanierDesc} from 'api-types/ffconnect-hal';

/**
 * Bouton Remplacer à droite de la corbeille sur une ligne de panier PDF :
 * même icône SwitchIcon que le Remplacer rupture / catalogue, gabarit DeleteButton.
 */
export const RemplacerLigneButton: React.FC<{
  ligneDePanier: State<LigneDePanierDesc>;
  remplacerSubmit: LigneDePanierCommands['remplacer']['submit'];
  isLoading?: boolean;
}> = ({ligneDePanier, remplacerSubmit, isLoading = false}) => {
  const {t} = useTranslation();
  const libelle = t('ligne_produit.indisponible.remplacer');

  const onClick = () => {
    ligneDePanier
      .follow('article')
      .get()
      .then((article) => {
        NiceModal.show(ModaleRemplacementCatalogue, {
          articleData: article.data,
          remplacerSubmit,
        });
      });
  };

  return (
    <Button
      variant='ghost'
      aria-label={libelle}
      title={libelle}
      h={{base: '20px', md: '35px'}}
      w='30px'
      px='0'
      minW='30px'
      onClick={onClick}
      isDisabled={isLoading}
    >
      {isLoading ? (
        <Spinner boxSize='18' />
      ) : (
        <SwitchIcon
          width='21'
          height='21'
          color='blue.100'
        />
      )}
    </Button>
  );
};
